/**
 * /manage/billing — MOCK. Plan / payment / invoices.
 *
 * The platform has no billing backend; this is a static mockup-faithful page so
 * the Manage section is visually complete. No API calls, no real state.
 */

import { createFileRoute } from "@tanstack/react-router";
import { Download } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { useDocumentTitle } from "@/lib/document-title";

export const Route = createFileRoute("/manage/billing")({
  component: BillingPage,
});

const HISTORY = [
  ["May 1, 2026", "$240.00", "Paid"],
  ["Apr 1, 2026", "$240.00", "Paid"],
  ["Mar 1, 2026", "$240.00", "Paid"],
];

function BillingPage() {
  useDocumentTitle(["Billing", "Manage"]);
  const [cycle, setCycle] = useState<"monthly" | "yearly">("monthly");
  const price = cycle === "monthly" ? "$240" : "$2,400";

  return (
    <div className="plan-skin">
      <div className="mx-auto max-w-[920px] px-10 py-9">
        <div className="manage-head">
          <div className="crumb">MANAGE</div>
          <h1 className="page">Billing</h1>
          <p className="page-sub">Plan, payment method and invoices.</p>
        </div>
        <hr className="rule" />

        <div className="manage-body">
          <div className="plan-card">
            <div>
              <div className="plan-eyebrow">Current plan</div>
              <div className="plan-name">Team</div>
              <div className="plan-meta">
                12 seats · {price}/{cycle === "monthly" ? "mo" : "yr"} · renews Jun 1, 2026
              </div>
            </div>
            <div className="plan-actions">
              <div className="inline-flex overflow-hidden rounded-md border border-border">
                <button
                  type="button"
                  className={`px-3 py-1.5 text-[12.5px] ${cycle === "monthly" ? "bg-[var(--lav)] text-[var(--lav-ink)]" : "text-muted-foreground"}`}
                  onClick={() => setCycle("monthly")}
                >
                  Monthly
                </button>
                <button
                  type="button"
                  className={`border-l border-border px-3 py-1.5 text-[12.5px] ${cycle === "yearly" ? "bg-[var(--lav)] text-[var(--lav-ink)]" : "text-muted-foreground"}`}
                  onClick={() => setCycle("yearly")}
                >
                  Yearly −20%
                </button>
              </div>
              <Button>Upgrade plan</Button>
            </div>
          </div>

          <div className="settings-section">
            <div className="settings-section-h">Payment method</div>
            <div className="flex items-center justify-between rounded-lg border border-border bg-card px-4 py-3">
              <div>
                <div className="text-sm text-foreground">Visa ending 4242</div>
                <div className="text-xs text-muted-foreground">expires 09/27</div>
              </div>
              <Button variant="outline">Manage payment</Button>
            </div>
          </div>

          <div className="settings-section">
            <div className="settings-section-h">Billing history</div>
            <div className="bill-list">
              {HISTORY.map((h) => (
                <div className="bill-row" key={h[0]}>
                  <span>{h[0]}</span>
                  <span className="font-mono">{h[1]}</span>
                  <span className="badge accepted">{h[2]}</span>
                  <Button variant="ghost" size="sm" className="h-7 justify-self-end gap-1.5 px-2 text-xs">
                    <Download className="size-3" /> Invoice
                  </Button>
                </div>
              ))}
            </div>
          </div>

          <div className="settings-actions">
            <Button variant="outline" className="danger-btn">
              Cancel subscription
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
